import { render, staticRenderFns } from "./QuestionCreateView.vue?vue&type=template&id=6242cbd8"
import script from "./QuestionCreateView.vue?vue&type=script&lang=js"
export * from "./QuestionCreateView.vue?vue&type=script&lang=js"
import style0 from "./QuestionCreateView.vue?vue&type=style&index=0&id=6242cbd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports